/**
 * Cart Icon Fix - Consolidated Solution
 * This script ensures the cart icon displays correctly during cart updates
 */

document.addEventListener("DOMContentLoaded", function() {
  // Add CSS styles for the cart icon
  addCartIconStyles();

  // Store the current cart count and track last update time
  let currentCartCount = 0;
  let cartIconInitialized = false;
  let lastUpdateTime = 0;
  let pendingUpdate = false;
  let isTransitioning = false;

  // Function to add CSS styles for the cart icon
  function addCartIconStyles() {
    const styleElement = document.createElement("style");
    styleElement.textContent = `
      /* Fix for item cart icon on product pages */
      .header__icon--cart .item-cart-container-not-empty {
        position: relative;
        display: flex;
        flex-direction: column;
        margin-left: 8px;
        margin-right: 8px;
        background-color: #ca5e1a;
        border: 2px solid #fff;
        width: 68px;
        height: 90px;
        border-radius: 12px;
        transition: all 0.1s linear;
      }

      .header__icon--cart .item-cart-container-not-empty:hover {
        border: 4px solid #fff;
      }

      .header__icon--cart .item-cart-container-not-empty:active {
        border: 2px solid #fff;
        background-color: #121214;
        color: #121214;
      }

      .header__icon--cart .item-cart-container-not-empty:active .item-cart-counter-container .item-cart-counter {
        color: #121214;
      }

      .header__icon--cart .item-cart-container-not-empty .icon-shopping-cart,
      .header__icon--cart .item-cart-container-empty .icon-shopping-cart {
        display: flex;
        height: 24px;
        margin: 8px 0;
      }

      .header__icon--cart .item-cart-container-not-empty .item-cart-text,
      .header__icon--cart .item-cart-container-empty .item-cart-text {
        display: flex;
        justify-content: center;
        width: 100%;
        font-size: 12px;
        line-height: 12px;
        text-align: center;
      }

      .header__icon--cart .item-cart-container-not-empty .item-cart-text {
        color: #fff;
      }

      .header__icon--cart .item-cart-container-empty .item-cart-text {
        color: #000;
      }

      .header__icon--cart .item-cart-container-not-empty .item-cart-counter-container {
        display: flex;
        justify-content: center;
        margin-top: 4px;
      }

      .header__icon--cart .item-cart-container-not-empty .item-cart-counter-container .item-cart-counter {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ca5e1a;
        font-weight: bold;
        background-color: #fff;
        border-radius: 26px;
        width: 36px;
        min-width: 36px;
        max-width: 36px;
        height: 18px;
        margin-top: 4px;
      }
    `;
    document.head.appendChild(styleElement);
  }

  // Function to fetch the current cart data and update the cart icon
  // with debouncing to prevent excessive API calls
  function updateCartIcon(forceUpdate = false) {
    const now = Date.now();

    // If an update is already pending or it's too soon since the last update (unless forced)
    if (pendingUpdate || (!forceUpdate && now - lastUpdateTime < 1000)) {
      return;
    }

    pendingUpdate = true;

    fetch("/cart.js")
      .then(response => response.json())
      .then(cart => {
        const newCartCount = cart.item_count || 0;
        lastUpdateTime = Date.now();
        pendingUpdate = false;

        // Only update if the count has changed
        if (newCartCount !== currentCartCount || !cartIconInitialized) {
          currentCartCount = newCartCount;
          updateCartDisplay(currentCartCount);
        }

        // Clear transition flag after update
        setTimeout(() => {
          isTransitioning = false;
        }, 100);
      })
      .catch(error => {
        console.error("Error fetching cart data:", error);
        pendingUpdate = false;
        isTransitioning = false;
      });
  }

  // Function to update the cart display based on count
  function updateCartDisplay(cartCount) {
    const cartIconBubble = document.getElementById("cart-icon-bubble");
    if (!cartIconBubble) return;

    // Check if we need to rebuild the entire structure
    const needsRebuild = !cartIconInitialized ||
                         (cartCount === 0 && cartIconBubble.querySelector(".item-cart-container-not-empty")) ||
                         (cartCount > 0 && !cartIconBubble.querySelector(".item-cart-container-not-empty"));

    if (needsRebuild) {
      // Full rebuild needed
      rebuildCartIcon(cartCount);
      cartIconInitialized = true;
    } else if (cartCount > 0) {
      // Just update the counter value to prevent flashing
      const counterElement = cartIconBubble.querySelector(".item-cart-counter");
      if (counterElement) {
        counterElement.textContent = cartCount.toString();
      }
    }
  }

  // Function to rebuild the cart icon structure (only used when necessary)
  function rebuildCartIcon(cartCount) {
    const cartIconBubble = document.getElementById("cart-icon-bubble");
    if (!cartIconBubble) return;

    // Create appropriate HTML based on cart count
    let cartHTML = "";
    if (cartCount === 0) {
      cartHTML = `
        <div class="item-cart-container">
          <div class="item-cart-container-empty">
            <img class="icon-shopping-cart" src="https://cdn.shopify.com/s/files/1/0717/3380/5285/files/icon-shopping-cart-black.svg?v=1741635364">
            <div class="item-cart-text">Cart</div>
          </div>
        </div>
      `;
    } else {
      cartHTML = `
        <div class="item-cart-container">
          <div class="item-cart-container-not-empty">
            <img class="icon-shopping-cart" src="https://cdn.shopify.com/s/files/1/0717/3380/5285/files/icon-shopping-cart.svg?v=1738033409">
            <div class="item-cart-text">Cart</div>
            <div class="item-cart-counter-container">
              <div class="item-cart-counter">${cartCount}</div>
            </div>
          </div>
        </div>
      `;
    }

    // Set the HTML content
    cartIconBubble.innerHTML = cartHTML;
  }

  // Function to perform an optimistic update for empty cart
  function updateEmptyCartToNonEmpty() {
    const cartIconBubble = document.getElementById("cart-icon-bubble");
    if (!cartIconBubble) return;

    // Only proceed if we have an empty cart container
    const emptyContainer = cartIconBubble.querySelector(".item-cart-container-empty");
    if (!emptyContainer || isTransitioning) return;

    isTransitioning = true;

    // Create the non-empty cart HTML
    const cartHTML = `
      <div class="item-cart-container">
        <div class="item-cart-container-not-empty">
          <img class="icon-shopping-cart" src="https://cdn.shopify.com/s/files/1/0717/3380/5285/files/icon-shopping-cart.svg?v=1738033409">
          <div class="item-cart-text">Cart</div>
          <div class="item-cart-counter-container">
            <div class="item-cart-counter">1</div>
          </div>
        </div>
      </div>
    `;

    // Set the HTML content
    cartIconBubble.innerHTML = cartHTML;
    currentCartCount = 1; // Update our internal count
  }

  // Initialize the cart icon
  updateCartIcon(true);

  // Helper function to check if a URL is cart-related
  function isCartUrl(url) {
    return typeof url === "string" && (
      url.includes("/cart/add") ||
      url.includes("/cart/update") ||
      url.includes("/cart/change") ||
      url.includes("/cart/clear")
    );
  }

  // Helper function to handle cart updates
  function handleCartUpdate(isAdd) {
    // For empty cart becoming non-empty, show optimistic update
    if (currentCartCount === 0 && isAdd) {
      updateEmptyCartToNonEmpty();
    }

    // Schedule a debounced update
    scheduleUpdate();
  }

  // Debounced update function
  let updateTimeout = null;
  function scheduleUpdate() {
    if (updateTimeout) {
      clearTimeout(updateTimeout);
    }
    updateTimeout = setTimeout(() => {
      updateCartIcon();
      updateTimeout = null;
    }, 300);
  }

  // Override fetch for cart operations
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    // Check if this is a cart-related request but NOT /cart.js itself
    const isCartOperation = isCartUrl(url);
    const isCartJs = typeof url === "string" && url.includes("/cart.js");
    const isAddOperation = typeof url === "string" && url.includes("/cart/add");

    // For cart operations (except /cart.js), handle optimistic updates
    if (isCartOperation && !isCartJs) {
      handleCartUpdate(isAddOperation);
    }

    // Call the original fetch
    const fetchPromise = originalFetch.apply(this, arguments);

    // For cart operations (except /cart.js), update after completion
    if (isCartOperation && !isCartJs) {
      fetchPromise.then(response => {
        // For add operations, try to get the count from the response
        if (isAddOperation) {
          const clonedResponse = response.clone();
          clonedResponse.json()
            .then(data => {
              if (data && typeof data.item_count !== "undefined") {
                const newCartCount = data.item_count;
                if (newCartCount !== currentCartCount) {
                  currentCartCount = newCartCount;

                  // Just update the counter text, don't rebuild the structure
                  const cartIconBubble = document.getElementById("cart-icon-bubble");
                  if (cartIconBubble) {
                    const counterElement = cartIconBubble.querySelector(".item-cart-counter");
                    if (counterElement) {
                      counterElement.textContent = newCartCount.toString();
                    }
                  }
                }
              }
            })
            .catch(() => {
              // If we can't parse the response, schedule an update
              scheduleUpdate();
            });
        }
        return response;
      });
    }

    return fetchPromise;
  };

  // Override XMLHttpRequest for older implementations
  const originalXhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    // Check if this is a cart-related request but NOT /cart.js itself
    const isCartOperation = isCartUrl(url);
    const isCartJs = typeof url === "string" && url.includes("/cart.js");
    const isAddOperation = typeof url === "string" && url.includes("/cart/add");

    // For cart operations (except /cart.js), handle optimistic updates
    if (isCartOperation && !isCartJs) {
      handleCartUpdate(isAddOperation);

      // Add a load event listener to update after completion
      this.addEventListener("load", function() {
        scheduleUpdate();
      });
    }

    // Call the original open method
    return originalXhrOpen.apply(this, arguments);
  };

  // Listen for Shopify cart events
  document.addEventListener("cart:updated", function() {
    scheduleUpdate();
  });

  document.addEventListener("cart:refresh", function() {
    scheduleUpdate();
  });

  // Listen for add to cart button clicks
  document.addEventListener("click", function(event) {
    const addToCartButton = event.target.closest("[type='submit'][name='add'], .add-to-cart, .product-form__submit");
    if (addToCartButton && currentCartCount === 0) {
      // Optimistic update for empty cart
      updateEmptyCartToNonEmpty();
    }
  });

  // Watch for DOM changes to the cart icon
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === "childList" && mutation.target.id === "cart-icon-bubble") {
        // Check if the structure is broken (neither container exists)
        const hasValidStructure =
          mutation.target.querySelector(".item-cart-container-not-empty") ||
          mutation.target.querySelector(".item-cart-container-empty");

        if (!hasValidStructure && !isTransitioning) {
          rebuildCartIcon(currentCartCount);
          cartIconInitialized = true;
        }
      }
    });
  });

  // Start observing the cart icon
  const cartIconBubble = document.getElementById("cart-icon-bubble");
  if (cartIconBubble) {
    observer.observe(cartIconBubble, { childList: true, subtree: true });
  }

  // Periodic refresh at a very low frequency - only as a fallback
  setInterval(() => updateCartIcon(), 30000);
});
